exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a.button.link{padding:.75em 2.5em .7em;margin:0!important;text-align:center}a.button.link:after{color:#fc3!important}div.tabHistory div.historical{padding-bottom:0!important}div.tabHistory div.historical p{text-align:center;margin:1.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/vehicle/manage-my-rlink/my-purchase-records/my-purchase-records.styl
// module id = 1122
// module chunks = 0